import { RETURN_PICKUP } from '@/utilities/trackingEvents';

/**
 * The `tracking_events` type each crossdocking checklist step records. Spread one into an
 * `openChecklist` call: `{ ...ORIGIN_PICKUP, title: ... }`. Both ChecklistModals read `itemEvent` (and
 * `returnItemEvent`, when set) to build the rows and pre-check items that already have theirs.
 *
 * Collected here because the interesting decision is not the forward event — it is whether a *return*
 * item inverts. It does where direction of travel changes what the step means (origin pickup,
 * delivery); it does not for warehouse moves, where a return does exactly what a forward item does.
 */

/** Collected from the customer's origin. A return on this order is collected from the consignee. */
export const ORIGIN_PICKUP = {
    itemEvent: 'ITEM_PICKED_UP_FROM_ORIGIN',
    returnItemEvent: RETURN_PICKUP,
};

/** Loaded out of a warehouse onto the truck. */
export const WAREHOUSE_LOAD = {
    itemEvent: 'ITEM_LOADED_FROM_WAREHOUSE',
};

/** Unloaded into a warehouse. */
export const WAREHOUSE_RECEIVE = {
    itemEvent: 'ITEM_RECEIVED_INTO_WAREHOUSE',
};

/** Handed to the consignee. A return on this order is instead collected from them. */
export const DELIVERY = {
    itemEvent: 'ITEM_DELIVERED',
    returnItemEvent: RETURN_PICKUP,
};

/**
 * Return-to-sender close-out. Deliberately does NOT invert, unlike DELIVERY: every item here is
 * already a return, and its consignee pickup happened on an earlier leg. This step is the delivery
 * *to the sender*, so swapping would re-record a pickup that already happened.
 */
export const RETURN_TO_SENDER_DELIVERY = {
    itemEvent: 'ITEM_DELIVERED',
};
